import axios from "axios";

// Create Axios instance
const API = axios.create({
  baseURL: "https://pink-dragonfly-673605.hostingersite.com/api", // backend URL
  // baseURL: "http://localhost:3000/api", // backend URL
});

// Attach token automatically
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("vendorToken");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle expired/invalid tokens globally
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("vendorToken");
      window.location.href = "/vendor/login"; // redirect to login
    }
    return Promise.reject(error);
  }
);

// API endpoints
export const loginVendor = (data) => API.post("/login", data);
export const registerVendor = (data) => API.post("/register", data);
export const getVendorDashboard = () => API.get("/dashboard"); // combines profile + orders
export const updateVendorProfile = (data) => API.put("/profile", data);
export const getVendorProfile = () => API.get("/profile");

export const updateOrderStatus = (orderId, status) =>
  API.put(`/orders/${orderId}/status`, { status });

export const sendForgotOTP = (email) =>
  API.post("/forgot-password", { email });

// Reset password using OTP
export const resetPassword = (email, otp, newPassword) =>
  API.post("/reset-password", { email, otp, newPassword });


export const addItemVendor = (formData) =>
  API.post("/vendor/items", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// Update an existing item (with optional new image)
export const updateItemVendor = (itemId, formData) =>
  API.put(`/vendor/items/${itemId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// Delete an item
export const deleteItemVendor = (itemId) => API.delete(`/vendor/items/${itemId}`);

// Get all items for logged-in vendor
export const getVendorItems = () => API.get("/vendor/all/items");

// Get single item by ID
export const getVendorItemById = (itemId) => API.get(`/vendor/items/${itemId}`);



export const getAllCategories = () => API.get("/categories-items"); // all categories with parent populated
export const getAllParentCategories = () => API.get("/categories-items/all-parent"); // only top-level parents
export const getSubcategoriesByParent = (parentId) =>
  API.get(`/categories-items/subcategories/${parentId}`); // subcategories of a parent
export const getParentWithSubcategories = () =>
  API.get("/categories-items/parent-with-sub"); // parent categories with their subcategories together


export const bulkUploadVendorItems = (file) => {
  const formData = new FormData();
  formData.append("file", file);

  return API.post("/vendor/items/bulk-upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};



export default API;
